<template>
  <BarChart />
</template>

<script>
import BarChart from './components/BarChart.vue'

export default {
  name: 'App',
  components: { BarChart }
}
</script>